export enum GRAPH_TIMESPANS {
  quarterly = 'quarterly',
  monthly = 'monthly',
}
